import Input from "src/components/Shared/Forms/Inputs/Input";

export default function LoginForm({ email, setEmail, password, setPassword, loginUser }) {
  return (
    <>
      <div className="w-full">
        <Input
          inline
          type="email"
          autoComplete="on"
          name="contact-email"
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && loginUser(e)}
        />
      </div>

      <div className="w-full min-w-[200px]">
        <Input
          inline
          autoComplete="on"
          type="password"
          name="password"
          label="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && loginUser(e)}
        />
      </div>
    </>
  );
}
